<template>
  <!-- 容器 -->
  <el-row type="flex" justify="center" align="middle" class="login-container">
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm">
      <!-- 用户名 -->
      <el-form-item label="用户名" prop="username">
        <el-input placeholder="请输入用户名" v-model="ruleForm.username" clearable></el-input>
      </el-form-item>
      <!-- 密码 -->
      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          placeholder="请输入密码"
          v-model="ruleForm.password"
          show-password
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <!-- 登录 -->
        <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        <!-- 重置 -->
        <el-button type="danger" @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
      <el-alert v-show="alertShow" class="login-wrong" title="用户名或密码错误" type="error" effect="dark"></el-alert>
    </el-form>
  </el-row>
</template>

<script>
import { admin_login } from '../api/api';
export default {
  data() {
    return {
        // 表单
      ruleForm: {
        username: "",
        password: ""
      },
      // 表单验证规则
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 5, max: 10, message: "用户名长度在 5 到 10 个字符", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 100, message: "密码长度在 6 到 15 个字符", trigger: "blur" }
        ]
      },
    //   登录警告
    alertShow: false
    };
  },
  methods: {
    // 提交表单
    submitForm(formName) {
      // 先验证表单
      this.$refs[formName].validate(valid => {
        // 验证成功
        if (valid) {
          // 发起请求
          admin_login(this.ruleForm.username,this.ruleForm.password)
          .then(res=>{
            
              localStorage.setItem('uname', res.username)
              localStorage.setItem('refreshToken',res.refreshToken)
              localStorage.setItem('token', res.accessToken)
              this.$router.push("/admin/goodslist");
              this.$message({
                  showClose: true,
                  message: `欢迎回来! ${res.username}`,
                  type:"success"
                })
          })
          .catch(err=>{
           
             // 否则弹框提示警告错误
             this.$message({
                  showClose: true,
                  message: err,
                  type:"error"
                })
          });
        } else {
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style scoped style="less">
.login-container {
  height: 100%;
  width: 100%;
  background-color: #2d434c;
}
.ruleForm {
  width: 350px;
  position: relative;
  padding: 50px 80px;
  border-radius: 20px;
  box-shadow: 0px 0px 12px 2px;
  background-color: #fff;
}
.login-wrong {
  width: 50%;
  position: absolute;
  left: 50%;
  top: -20%;
  transform: translateX(-50%);
}
</style>